import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import AdminLock from './icon-admin-lock.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <AdminLock {...validProps} />;
}
SvgComponent.iconName = 'admin-lock';

/**
 * @deprecated This is a legacy icon
 */
export const AdminLockIcon = svgIconWrapper(SvgComponent);
